
/* eslint-disable @typescript-eslint/camelcase */
import {
  directDownloadFile,
  reportTypeToTitle,
  sleep
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import groupBy from "lodash/groupBy";
import { Options, Vue, prop } from "vue-class-component";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { ApiRequestList } from "@/domain/entities/MainApp";
import downloadFile from "@/app/infrastructures/misc/common-library/DownloadFile";

class Props {
  id = prop<string>({
    default: "",
    type: String
  });
  customTitle = prop<string>({
    default: "",
    type: String
  });
  isCloseable = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  components: {
    Skeleton
  },
  emits: ["close"]
})
export default class WidgetDownload extends Vue.with(Props) {
  get bulkDownload() {
    return PusatResolusiV2Controller.bulkDownload;
  }
  getBulkDownload() {
    PusatResolusiV2Controller.getBulkDownload(
      new ApiRequestList({
        page: this.bulkDownload.pagination.page,
        limit: this.bulkDownload.pagination.limit
      })
    );
  }

  unmounted() {
    clearInterval(this.requestInInterval);
  }

  requestInInterval: any = null;

  initiateGetListDownloadReport() {
    this.getBulkDownload();
    this.requestInInterval = setInterval(
      () => {
        if (this.haveWaitingAndToday) {
          this.getBulkDownload();
        }
      },
      10000 // interval every 10 seconds
    );
  }

  get haveWaitingAndToday() {
    return this.bulkDownload.data.some(
      (data) =>
        data.status === "waiting" &&
        new Date(data.createdAt).getDate() === new Date().getDate()
    );
  }

  get openWidgetDownload() {
    return PusatResolusiV2Controller.bulkDownloadConditions.openWidgetDownload;
  }

  get loading() {
    return PusatResolusiV2Controller.bulkDownloadConditions.loading;
  }

  onToggleMenu() {
    if (this.openWidgetDownload) {
      PusatResolusiV2Controller.closeWidgetDownload();
      return;
    }

    PusatResolusiV2Controller.openWidgetDownload();
  }
  async onDownload(item: any) {
    const files = item.url.split(",");
    for (const file of files) {
      if (file) {
        if (item.isRequireToken) {
          downloadFile(
            file,
            `${item.type}_${new Date().getTime()}`,
            ".xlsx",
            true,
            60000,
            "GET"
          );
        } else {
          directDownloadFile(file);
        }
        await sleep(500);
      }
    }
  }
  numberOfFiles(item: any) {
    const files = item.url.split(",");
    return files.length ? `(${files.length})` : "";
  }

  mounted() {
    this.bulkDownload.pagination.limit = 20;
    this.initiateInfiniteScroll();
    this.initiateGetListDownloadReport();
  }

  initiateInfiniteScroll() {
    const getNewData = () => {
      this.bulkDownload.pagination.limit += 10;
      this.getBulkDownload();
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          getNewData();
        }
      });
    }, {});

    const element: any = document.querySelector("#infinite-scroll");
    observer.observe(element);
  }

  get downloadRequestList() {
    const data = this.bulkDownload.data.map((item) => {
      const date = formatDate(item.createdAt)?.split(",")[0];
      const time = formatDate(item.createdAt)?.split(",")[1];

      const addition = {
        title: `${time?.split(" ")[1]} - ${this.reportTitle(item)}`,
        dateString: date
      };
      return { ...item, ...addition };
    });
    const grouped = groupBy(data, "dateString");
    return Object.keys(grouped).map((item) => grouped[item]);
  }

  reportTitle(item: any) {
    if (this.isForeignAccount) {
      return `${item.type.includes("dashboard") ? "" : ""} ${reportTypeToTitle[
        item.type
      ] || item.type} ${this.$t("Laporan")}`;
    } else {
      return `${
        item.type.includes("dashboard") ? "" : this.$t("Laporan")
      } ${reportTypeToTitle[item.type] || item.type}`;
    }
  }

  get isForeignAccount() {
    return AccountController.accountData.accountIsForeign;
  }

  get isShowRunningText() {
    return !!FlagsMedusa.information_running_text.getValue().replace(" | ", "");
  }

  onClose(e: any) {
    e.stopPropagation();
    PusatResolusiV2Controller.closeWidgetDownload();
    this.$emit("close");
  }
}
